module.exports = __webpack_public_path__ + "img/2.4c6e0358.jpg";